import React, { useCallback, useState } from "react";
import { AFREECATV_URL, SUPPORT_URL, VTVLIVE_URL } from "./constants/config";
export default function Footer() {
  var lang = document.documentElement.lang;

  var _a = useState(false),
      family = _a[0],
      setFamily = _a[1];

  var handleFamilyClick = useCallback(function (e) {
    e.preventDefault();
    setFamily(!family);
  }, [family]);
  return React.createElement("div", {
    id: "footer"
  }, React.createElement("div", {
    className: "footer-container"
  }, React.createElement("div", {
    className: "footer-wrapper"
  }, React.createElement("a", {
    className: "footer-link",
    href: AFREECATV_URL,
    target: "_blank"
  }, "Trang ch\u1EE7"), React.createElement("a", {
    className: "footer-link",
    href: VTVLIVE_URL,
    target: "_blank"
  }, "Th\xF4ng tin"), React.createElement("a", {
    className: "footer-link",
    href: SUPPORT_URL,
    target: "_blank"
  }, "Li\xEAn h\u1EC7"), React.createElement("a", {
    className: "footer-link",
    href: AFREECATV_URL + "/terms-of-service",
    target: "_blank"
  }, "\u0110i\u1EC1u kho\u1EA3n d\u1ECBch v\u1EE5"), React.createElement("a", {
    className: "footer-link",
    href: AFREECATV_URL + "/community-standard",
    target: "_blank"
  }, "Ti\xEAu chu\u1EA9n c\u1ED9ng \u0111\u1ED3ng"), React.createElement("a", {
    className: "footer-link",
    href: AFREECATV_URL + "/privacy-policy",
    target: "_blank"
  }, "Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0"), React.createElement("a", {
    className: "footer-link",
    href: AFREECATV_URL + "/guide-for-guardian",
    target: "_blank"
  }, "H\u01B0\u1EDBng d\u1EABn ng\u01B0\u1EDDi gi\xE1m h\u1ED9")), React.createElement("div", {
    className: "copyright"
  }, "\xA9 2023 ON Live Copyright All Rights Reserved")));
}